<template>
    <new-modal title="Change Password" ref="changePasswordModal">
        <template #trigger>
            <span class="link absolute right-0 top-0 text-[14px]"
                >Change Password</span
            >
        </template>
        <template #content>
            <div>
                <form class="form" @submit.prevent="submitForm">
                    <div class="w-full">
                        <div class="input-group">
                            <form-input
                                v-model="form.current_password"
                                name="current_password"
                                label="Current Password"
                                type="password"
                            />
                        </div>

                        <div class="input-group">
                            <form-input
                                v-model="form.new_password"
                                name="new_password"
                                label="New Password"
                                type="password"
                            />
                        </div>

                        <div class="input-group">
                            <form-input
                                v-model="form.new_password_confirmation"
                                name="new_password_confirmation"
                                label="Confirm New Password"
                                type="password"
                            />
                        </div>

                        <div class="mt-4">
                            <button
                                type="submit"
                                :class="
                                    'btn btn-sm ' +
                                    (form.isDirty
                                        ? 'btn-primary'
                                        : 'btn-disabled')
                                "
                            >
                                Change Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </new-modal>
</template>

<script>
import FormInput from "@/Components/FormInput";
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "UserChangePassword",
    components: {
        NewModal,
        FormInput,
    },
    emits: ["password-changed"],
    data() {
        return {
            form: this.$inertia.form({
                current_password: null,
                new_password: null,
                new_password_confirmation: null,
            }),
        };
    },
    methods: {
        submitForm: function (e) {
            let vm = this;

            this.$inertia.post(
                "/user/update-user-password",
                {
                    current_password: vm.form.current_password,
                    new_password: vm.form.new_password,
                    new_password_confirmation:
                        vm.form.new_password_confirmation,
                },
                {
                    onSuccess: function () {
                        vm.$refs.changePasswordModal.closeModal();
                        vm.$page.props.flash.success = ["Password updated"];
                    },
                }
            );
        },
    },
};
</script>

<style scoped></style>
